//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'm-panel',
  props: [
    'close',
    'title',
    'label',
    'messagePanel'
  ],
  computed: {
    themeColor () {
      if (this.$store.state.config.themeColor !== undefined) {
        return this.$store.state.config.themeColor
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Panel.vue